import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0B1120] flex items-center justify-center p-4">
      <Card className="bg-[#111827] border-white/10 max-w-md w-full">
        <CardContent className="p-8 text-center">
          <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-white mb-2">Payment Cancelled</h1>
          <p className="text-slate-400 mb-6">
            Your payment was cancelled. No charges have been made to your account.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button 
              onClick={() => navigate(-1)}
              variant="outline"
              className="border-slate-600 text-slate-300 hover:bg-white/10"
            >
              Try Again
            </Button>
            <Button 
              onClick={() => navigate('/dashboard')}
              className="bg-[#4A90D9] hover:bg-[#3A80C9]"
              data-testid="back-to-dashboard"
            >
              Back to Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
